import template from './print_branch_coin.html';
import controller from './print_branch_coin.controller';
import './print_branch_coin.scss';

let printComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default printComponent;


// WEBPACK FOOTER //
// ./client/app/components/coin_pull_report/print_branch_coin/print_branch_coin.component.js